import type { DataGridCoreTable, RowData } from '../types';

// The one place a pinned column's sticky offset is computed — header cell and body cell both call
// this with the same (table, columnId, pinned) inputs, so the two can never drift apart the way two
// independently-hand-rolled offset calculations could.
export function getPinnedOffset<TRow extends RowData>(
  table: DataGridCoreTable<TRow>,
  columnId: string,
  pinned: 'start' | 'end' | false,
): number | undefined {
  if (!pinned) return undefined;

  const columns =
    pinned === 'start' ? table.getStartVisibleLeafColumns() : table.getEndVisibleLeafColumns();
  const index = columns.findIndex((column) => column.id === columnId);
  if (index === -1) return undefined;

  // 'start': sum the columns before this one, so the leftmost pinned column sits flush at 0.
  // 'end': sum the columns after this one, so the rightmost pinned column sits flush at 0.
  const precedingInStickDirection =
    pinned === 'start' ? columns.slice(0, index) : columns.slice(index + 1);
  return precedingInStickDirection.reduce((sum, column) => sum + column.getSize(), 0);
}
